import React from "react";
import { FormGroup, InputText, Button } from "@accessdev/arc-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { Creators } from "@ReduxStore/actionTypes";
import { selectors } from "@ReduxStore/reducers";
import { errorLocations, signUpSteps } from "../../authHelpers";
import { Member, PASSWORD_MIN_STR } from "@Src/constants/";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import Captcha from "../Captcha";

function MemberID(props) {
  const { _ } = useLingui();
  const inputRef = React.useRef(null);
  const registrationStatus = useSelector(selectors.getRegistrationStatus);
  const dispatch = useDispatch();

  const handleNextStep = React.useCallback(() => {
    dispatch(Creators.setSignUpStep(signUpSteps.NAME));
  }, [dispatch]);

  React.useEffect(() => {
    if (registrationStatus === Member.MEMBER_ID_VERIFIED) {
      !props.isPhone ? props.completeSignUp() : handleNextStep();
    }
  }, [registrationStatus, props, handleNextStep]);

  React.useEffect(() => {
    if (inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 200);
    }
  }, [inputRef]);

  const onSubmit = (event) => {
    dispatch(Creators.checkMemberId(props.values.memberID));
  };

  return (
    <FormGroup onSubmit={onSubmit}>
      <div className="SignUp-form_memberID-container">
        <InputText
          {...{
            ref: inputRef,
            errorMsg: _(props.showError(errorLocations.SIGN_UP_MEMBERID)),
            id: "memberID",
            isRequired: true,
            label: props.memberKeyLabel || t`Member ID`,
            labelInfo: props.memberKeyDescription || null,
            name: "memberID",
            onChange: props.onValueChange,
            type: "text",
            value: props.values.memberID,
            variant: "SignUp-form_memberID",
            requiredLabel: "",
            ...(props.error && props.error.location === errorLocations.SIGN_UP_MEMBERID
              ? { isError: true }
              : null),
          }}
        />
      </div>

      {registrationStatus === Member.INVALID_CAPTCHA && (
        <Captcha
          doReveal={props.values.passwordStr >= PASSWORD_MIN_STR}
          onVerify={props.onCaptchaVerify}
        />
      )}

      <Button
        type="submit"
        className="SignUpWizard-nextSubmitBtn"
        isDisabled={registrationStatus === Member.REGISTERING}
      >
        <Trans>Verify Membership</Trans>
      </Button>
    </FormGroup>
  );
}

export default MemberID;
